import { render, staticRenderFns } from "./wlmz-record-player-dialog.vue?vue&type=template&id=353e153e&scoped=true&"
import script from "./wlmz-record-player-dialog.vue?vue&type=script&lang=js&"
export * from "./wlmz-record-player-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353e153e",
  null
  
)

export default component.exports